import TournamentTemplateTable from './components/TournamentTemplateTable';
import TournamentTemplateModalForm from './components/TournamentTemplateModalForm';
import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import StandardLayout from '@/common/layouts/StandardLayout';
import { FaPlus } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';

const TournamentTemplatesPage = () => {
  const [formOpen, setFormOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const templateId = searchParams.get('templateId');
    if (templateId) {
      setSelectedTemplateId(templateId);
      setFormOpen(true);
      // Clear the query string
      setSearchParams({});
    }
  }, []);

  const openForm = () => setFormOpen(true);
  const closeForm = () => {
    setFormOpen(false);
    setSelectedTemplateId(null);
  };

  const onSelectTemplate = (templateId: string) => {
    setSelectedTemplateId(templateId);
    openForm();
  };

  return (
    <StandardLayout
      pageTitle="Tournament Templates"
      headerButton={
        <Button onClick={openForm} color="primary" className="d-flex align-items-center gap-2">
          <FaPlus />
          <p className="mb-0">Add Tournament Template</p>
        </Button>
      }
    >
      <TournamentTemplateTable onSelectTemplate={onSelectTemplate} />
      {formOpen && <TournamentTemplateModalForm onClose={closeForm} selectedTemplateId={selectedTemplateId} />}
    </StandardLayout>
  );
};

export default TournamentTemplatesPage;
